"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _consts = require("../consts");
var _Apple = _interopRequireDefault(require("../../icons/Apple"));
var _Google = _interopRequireDefault(require("../../icons/Google"));
var _Facebook = _interopRequireDefault(require("../../icons/Facebook"));
var _X = _interopRequireDefault(require("../../icons/X"));
var _Email = _interopRequireDefault(require("../../icons/Email"));
const getSocialButtonIcon = type => {
  if (type === _consts.TYPE_OPTIONS.APPLE) return /*#__PURE__*/React.createElement(_Apple.default, {
    ariaHidden: true
  });
  if (type === _consts.TYPE_OPTIONS.FACEBOOK) return /*#__PURE__*/React.createElement(_Facebook.default, {
    ariaHidden: true
  });
  if (type === _consts.TYPE_OPTIONS.GOOGLE) return /*#__PURE__*/React.createElement(_Google.default, {
    ariaHidden: true
  });
  if (type === _consts.TYPE_OPTIONS.X) return /*#__PURE__*/React.createElement(_X.default, {
    ariaHidden: true
  });
  if (type === _consts.TYPE_OPTIONS.EMAIL) return /*#__PURE__*/React.createElement(_Email.default, {
    ariaHidden: true
  });
  return null;
};
var _default = exports.default = getSocialButtonIcon;